import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Star, Quote } from 'lucide-react';
import { useLang } from '../i18n/LanguageContext';
import BrandSlider from './BrandSlider';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Testimonials() {
  const [items, setItems] = useState([]);
  const { t } = useLang();

  useEffect(() => {
    axios.get(`${API}/testimonials`).then(r => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        {/* Trusted By — auto sliding brand marquee */}
        <div className="mb-20">
          <p className="text-center text-[color:var(--brand)] uppercase tracking-[0.4em] text-xs mb-8" data-testid="trusted-by-label">
            {t('testimonials.trustedBy')}
          </p>
          <BrandSlider />
        </div>

        {/* Testimonials */}
        <div className="text-center max-w-2xl mx-auto mb-12">
          <p className="text-[color:var(--brand)] uppercase tracking-[0.4em] text-xs mb-4">{t('testimonials.eyebrow')}</p>
          <h2 className="text-4xl md:text-5xl font-light text-[color:var(--ink)] mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>{t('testimonials.title')}</h2>
          <div className="mx-auto w-16 h-[2px] bg-[color:var(--brand)]" />
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {items.map(item => (
            <div key={item.id} className="p-8 bg-[color:var(--brand-soft)]/30 rounded-md border border-[color:var(--line)] hover:shadow-lg transition-shadow">
              <Quote className="text-[color:var(--brand)] mb-4" size={28} />
              <p className="text-[color:var(--ink)] leading-relaxed mb-5">“{item.quote}”</p>
              <div className="flex items-center gap-1 mb-3">
                {Array.from({length: item.rating}).map((_, i) => (<Star key={i} size={16} className="fill-yellow-400 text-yellow-400" />))}
              </div>
              <div className="font-semibold text-[color:var(--ink)]">{item.name}</div>
              <div className="text-sm text-[color:var(--muted)]">{item.role}, {item.company}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
